/** tempexp_14728-full-file */
import React, { FC } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { Download } from 'reactApp/ui/DataListItemCommonComponents/Download/Download';
import { Favorite } from 'reactApp/ui/DataListItemCommonComponents/Favorite/Favorite';
import { Progress } from 'reactApp/ui/DataListItemCommonComponents/Progress/Progress';
import { Publish } from 'reactApp/ui/DataListItemCommonComponents/Publish/Publish';
import { Date } from 'reactApp/ui/DataListItemRow/components/Date/Date';
import { Expires } from 'reactApp/ui/DataListItemRow/components/Expires/Expires';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { ItemTip } from 'reactApp/ui/DataListItemRow/components/ItemTip/ItemTip';
import { Pic } from 'reactApp/ui/DataListItemRow/components/Pic/Pic';
import { Size } from 'reactApp/ui/DataListItemRow/components/Size/Size';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import { HomeItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

interface HomeProps extends HomeItemProps {
    checkboxClassname?: string;
    favoriteClassname?: string;
}

export const Home: FC<HomeProps> = (props) => {
    const { denyDoAction: isProgress, tipData, isFolder, checkboxClassname, favoriteClassname, progress, onCancelUpload, isPublic } = props;

    return (
        <>
            <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
            <TableColumn>
                <Checkbox
                    viewType={EViewMode.list}
                    className={checkboxClassname}
                    onCheckboxClick={props.onCheckboxClick}
                    isSelected={props.isSelected}
                    isDisabled={isProgress}
                />
                <Pic
                    isFolder={props.isFolder}
                    thumbUrl={props.thumbUrl}
                    kind={props.kind}
                    isVirus={!!props.isVirus}
                    ext={props.ext || ''}
                    author={props.author}
                    isAutoDelete={props?.isAutoDelete}
                    publicExpires={props.publicExpires}
                    isPublic={isPublic}
                />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName
                    name={props.name}
                    ext={props.ext || ''}
                    loading={isProgress}
                    id={props.id}
                    isRenameAvailable={props.renameAvailable}
                />
            </TableColumn>
            {props.isFolder && Boolean(props.publicExpires) && (
                <TableColumn flexBasis={140} flexShrink={0} justifyContent="flex-end">
                    <Expires expires={props.publicExpires} isAutoDelete={props.isAutoDelete} />
                </TableColumn>
            )}
            {!props.isFolder && (
                <TableColumn flexBasis={140} flexShrink={0} justifyContent="flex-end">
                    <Date date={props.mtime} />
                </TableColumn>
            )}
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            {!isProgress && (
                <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                    <Favorite
                        className={favoriteClassname}
                        isAvailable={!!props.favoritesAvailable}
                        isFavorite={!!props.isInFavorites}
                        onClick={props.onFavorites}
                        viewType={EViewMode.list}
                    />
                    <Publish viewType={EViewMode.list} onClick={props.onPublish} isShared={props.isPublic} />
                    <Download
                        onClick={props.onDownload}
                        ext={props.isFolder ? 'zip' : props.ext}
                        size={props.size}
                        id={props.id}
                        storage={props.storage}
                        viewType={EViewMode.list}
                    />
                </TableColumn>
            )}
            {isProgress && typeof progress === 'number' && (
                <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                    <Progress onClick={onCancelUpload} progress={progress} />
                </TableColumn>
            )}
        </>
    );
};
